import { DownloadResumePdf } from 'types/download.type'

export const downloadFile = (response: DownloadResumePdf, fileName: string): void => {
  const href = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
}
